import { render, staticRenderFns } from "./AllegacyFooterInvestment.vue?vue&type=template&id=514ec29a&scoped=true"
import script from "./AllegacyFooterInvestment.vue?vue&type=script&lang=ts"
export * from "./AllegacyFooterInvestment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514ec29a",
  null
  
)

export default component.exports